import { api } from './api';
import type { TelegramLoginOptions } from '@etap/shared';

export interface TelegramLoginSdk {
  auth(options: { client_id: number; nonce: string; scope: string[]; lang: string },
    callback: (result: { id_token?: string; error?: string }) => void): void;
  close(): void;
}

let sdkPromise: Promise<TelegramLoginSdk> | undefined;
let optionsPromise: Promise<TelegramLoginOptions> | undefined;

// Deduplicate React StrictMode's effect requests so they cannot race nonce cookies.
export function getTelegramLoginOptions() {
  optionsPromise ??= api.getTelegramLoginOptions().finally(() => { optionsPromise = undefined; });
  return optionsPromise;
}

export function loadTelegramLoginSdk(): Promise<TelegramLoginSdk> {
  if (window.Telegram?.Login) return Promise.resolve(window.Telegram.Login);
  if (!sdkPromise) {
    sdkPromise = new Promise<TelegramLoginSdk>((resolve, reject) => {
      const script = document.createElement('script');
      const fail = () => {
        clearTimeout(timeout);
        script.remove();
        sdkPromise = undefined;
        reject(new Error('Telegram Login SDK unavailable'));
      };
      const timeout = window.setTimeout(fail, 12_000);
      script.src = 'https://oauth.telegram.org/js/telegram-login.js';
      script.async = true;
      script.onerror = fail;
      script.onload = () => {
        clearTimeout(timeout);
        if (window.Telegram?.Login) resolve(window.Telegram.Login);
        else fail();
      };
      document.head.appendChild(script);
    });
  }
  return sdkPromise;
}
